




































import { Vue, Component, Prop } from 'vue-property-decorator';
import { News } from '@/types/contentServerContract';
import SmartParagraph from '@/core/ui-components/SmartParagraph.vue';
import { extensionIsGifOrUndefined } from '@/project/shared/responsive-umbraco-image.service';

@Component({
    components: { SmartParagraph }
})
export default class NewsArticleTeaser extends Vue {
    @Prop({ required: true })
    private news!: News;

    private get newsImageFormat() {
        return extensionIsGifOrUndefined(this.news?.image);
    }
}
